import axios from 'axios';

function initPhoneCall(phone, success = () => {
}, error = () => {
}) {
  return axios
    .post('/tourclient/api/Telephony/Call', `number=${phone}`)
    .then(({ data }) => {
      switch (data.CallResultType) {
        case 0:
          console.log(`'initialized call to ${phone}`);
          success();
          break;
        case 1:
          error('Для совершения звонков из MAG.travel необходимо настроить <a href="/tourclient/admin/telephony/settings.html">интеграцию с телефонией</a>.');
          break;
        case 2:
          error('У вас не указан внутренний номер в настройках IP-телефонии');
          break;
        case 3:
        default:
          error('При наборе номера произошла ошибка. Проверьте соответствие номеров указанных у поставщика номерам указанным в настройках телефонии');
          break;
      }
    });
}

window.initPhoneCall = initPhoneCall;

export default initPhoneCall;
